import { useEffect, useState } from "react";

export const useMediaQuery = (width: number) => {
  const [isSmall, setIsSmall] = useState<boolean>(false);
  useEffect(() => {
    const updateScreenSize = () => {
      if (window.innerWidth < width) {
        setIsSmall(true);
      } else {
        setIsSmall(false);
      }
    };

    window.addEventListener("resize", updateScreenSize);

    updateScreenSize();

    return () => {
      window.removeEventListener("resize", updateScreenSize);
    };
  }, [width]);

  return isSmall;
};
